import { render, staticRenderFns } from "./generalChannelReport.vue?vue&type=template&id=19eb8a7a&scoped=true"
import script from "./generalChannelReport.vue?vue&type=script&lang=js"
export * from "./generalChannelReport.vue?vue&type=script&lang=js"
import style0 from "./generalChannelReport.vue?vue&type=style&index=0&id=19eb8a7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19eb8a7a",
  null
  
)

export default component.exports